<!-- Main Dashboard Container -->
<div class="flex-1 bg-muted flex flex-col min-w-0 h-full overflow-hidden">
    <div class="flex-1 overflow-y-auto flex flex-row min-h-0">

        <!-- Left Main Content Area -->
        <div class="flex-1 min-w-0 bg-muted">
            <!-- Dashboard Header Start -->
            <div class="flex items-center justify-between px-3 flex-shrink-0 bg-muted">
                <div class="flex flex-col gap-2">
                    <div class="flex items-center gap-2">
                        <h2 class="text-foreground font-bold text-2xl tracking-tight mt-0 pt-3">Tổng quan tài sản</h2>
                    </div>
                </div>
            </div>

            <!-- Stats Overview Cards -->
            <div class="gap-3 px-3 mb-3 home-dashboard__stats">
                <div
                    class="bg-white p-3 border border-slate-200 rounded-lg shadow-sm flex flex-col justify-center transition-transform hover:scale-[1.02] cursor-default">
                    <h5 class="text-muted-foreground tracking-tighter mb-1 text-xs font-medium m-0">Tổng tài sản</h5>
                    <h2 class="text-slate-800 leading-tight m-0 text-2xl font-bold">203</h2>
                </div>
                <div
                    class="bg-white p-3 border border-slate-200 rounded-lg shadow-sm flex flex-col justify-center transition-transform hover:scale-[1.02] cursor-default">
                    <h5 class="text-muted-foreground tracking-tighter mb-1 text-xs font-medium m-0">Đang sử dụng</h5>
                    <h2 class="text-blue-600 leading-tight m-0 text-2xl font-bold">149</h2>
                </div>
                <div
                    class="bg-white p-3 border border-slate-200 rounded-lg shadow-sm flex flex-col justify-center transition-transform hover:scale-[1.02] cursor-default">
                    <h5 class="text-muted-foreground tracking-tighter mb-1 text-xs font-medium m-0">Chưa sử dụng</h5>
                    <h2 class="text-slate-800 leading-tight m-0 text-2xl font-bold">3</h2>
                </div>
                <div
                    class="bg-white p-3 border border-slate-200 rounded-lg shadow-sm flex flex-col justify-center transition-transform hover:scale-[1.02] cursor-default">
                    <h5 class="text-muted-foreground tracking-tighter mb-1 text-xs font-medium m-0">Bình thường</h5>
                    <h2 class="text-emerald-600 leading-tight m-0 text-2xl font-bold">151</h2>
                </div>
                <div
                    class="bg-orange-50 px-3 pt-2 pb-2 border border-orange-100 rounded-lg shadow-sm flex flex-col justify-center transition-transform hover:scale-[1.02] cursor-default">
                    <h5 class="text-orange-700 tracking-tighter mb-1 text-xs font-medium m-0">Hỏng</h5>
                    <h2 class="text-orange-600 leading-tight m-0 text-2xl font-bold">1</h2>
                </div>
                <div
                    class="bg-red-50 px-3 pt-2 pb-2 border border-red-100 rounded-lg shadow-sm flex flex-col justify-center transition-transform hover:scale-[1.02] cursor-default">
                    <h5 class="text-red-700 tracking-tighter mb-1 text-xs font-medium m-0">Mất</h5>
                    <h2 class="text-red-600 leading-tight m-0 text-2xl font-bold">0</h2>
                </div>
            </div>

            <!-- Asset Type Summary Section Start -->
            <div class="px-3 pb-4">
                <div class="home-dashboard__content">
                    <!-- Main Table Card -->
                    <div class="home-dashboard__card">
                        <!-- Table Header -->
                        <div class="home-dashboard__card-header">
                            <h3 class="home-dashboard__card-title text-sm font-medium">
                                Tổng hợp loại tài sản
                                <button class="home-dashboard__icon-button hover:text-blue-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="home-dashboard__icon">
                                        <path fill-rule="evenodd"
                                            d="M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </button>
                            </h3>
                            <div class="home-dashboard__toolbar">
                                <!-- Search Input -->
                                <div class="home-dashboard__search">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="home-dashboard__search-icon">
                                        <path fill-rule="evenodd"
                                            d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                    <input [(ngModel)]="query.filter" type="text" autocomplete="off"
                                        (keyup.enter)="query.offSet = 0; first = 0; load()" placeholder="Tìm kiếm"
                                        class="home-dashboard__search-input" />
                                </div>
                                <!-- Customize Button -->
                                <app-icon-button label="Tuỳ chỉnh" (btnClick)="toggleCustomGrid()">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        aria-hidden="true" data-slot="icon" class="w-7 h-7">
                                        <path
                                            d="M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z">
                                        </path>
                                    </svg>
                                </app-icon-button>
                            </div>
                        </div>

                        <!-- AG Grid Table -->
                        <div class="grid-default" #container>
                            <app-list-grid-angular *ngIf="columnDefs1.length > 0 && heightGrid > 0"
                                [listsData]="listsData1" [height]="heightGrid" [columnDefs]="columnDefs1"
                                [floatingFilter]="false" [rowSelection]="'multiple'" #gridList
                                [overlayNoRowsTemplate]="noRowsTemplate">
                            </app-list-grid-angular>
                        </div>

                        <div class="app-paginator-footer">
                            <span class="app-paginator-footer__text">
                                Từ {{ countRecord.currentRecordStart }} đến {{ listsData1.length }} trên tổng số {{
                                listsData1.length }} kết quả
                            </span>
                            <div class="app-paginator-footer__items">
                                <p-paginator [rows]="query.pageSize" [totalRecords]="countRecord.totalRecord"
                                    [first]="first" (onPageChange)="paginate($event)"
                                    [rowsPerPageOptions]="[15,30,45,100,200,{ showAll: 'ALL' }]">
                                </p-paginator>
                            </div>
                        </div>
                    </div>

                    <!-- Three-Column Grid Section -->
                    <div class="home-dashboard__mini-grid">
                        <!-- Column 1: Newly Allocated Assets -->
                        <div class="home-dashboard__mini-card">
                            <div class="home-dashboard__mini-header">
                                <div class="flex items-center gap-2">
                                    <h3 class="home-dashboard__mini-title">Mới cấp phát
                                    </h3>
                                    <button
                                        class="home-dashboard__icon-button home-dashboard__icon-button--compact hover:text-blue-600">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            class="home-dashboard__icon home-dashboard__icon--compact">
                                            <path fill-rule="evenodd"
                                                d="M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                                <button
                                    class="!w-8 !h-8 !min-w-[32px] !min-h-[32px] !p-0 flex-none self-center flex items-center justify-center bg-card border border-primary text-secondary rounded-lg hover:bg-[#ebf3ff] transition-colors shadow-sm">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            aria-hidden="true" data-slot="icon" class="w-6 h-6 text-primary">
                                            <path
                                                d="M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z">
                                            </path>
                                        </svg>
                                </button>
                            </div>
                            <div class="home-dashboard__mini-body">
                                <div class="grid-default" #container>
                                    <app-list-grid-angular *ngIf="columnDefs2.length > 0 && heightGrid > 0"
                                        [listsData]="listsData2" [height]="heightGrid1" [columnDefs]="columnDefs2"
                                        [floatingFilter]="false" [rowSelection]="'multiple'" #gridList
                                        [overlayNoRowsTemplate]="noRowsTemplate">
                                    </app-list-grid-angular>
                                </div>
                            </div>
                            <div class="home-dashboard__mini-footer">
                                <span class="home-dashboard__mini-footer-text">Tổng số {{allocate_grid.length}} kết
                                    quả</span>
                            </div>
                        </div>

                        <!-- Column 2: Newly Revoked Assets -->
                        <div class="home-dashboard__mini-card">
                            <div class="home-dashboard__mini-header">
                                <div class="flex items-center gap-2">
                                    <h3 class="home-dashboard__mini-title">Mới thu hồi
                                    </h3>
                                    <button
                                        class="home-dashboard__icon-button home-dashboard__icon-button--compact hover:text-blue-600">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            class="home-dashboard__icon home-dashboard__icon--compact">
                                            <path fill-rule="evenodd"
                                                d="M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                                <button
                                    class="!w-8 !h-8 !min-w-[32px] !min-h-[32px] !p-0 flex-none self-center flex items-center justify-center bg-card border border-primary text-secondary rounded-lg hover:bg-[#ebf3ff] transition-colors shadow-sm">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            aria-hidden="true" data-slot="icon" class="w-6 h-6 text-primary">
                                            <path
                                                d="M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z">
                                            </path>
                                        </svg>
                                </button>
                            </div>
                            <div class="home-dashboard__mini-body">
                                <div class="grid-default" #container>
                                    <app-list-grid-angular *ngIf="columnDefs3.length > 0 && heightGrid > 0"
                                        [listsData]="listsData3" [height]="heightGrid1" [columnDefs]="columnDefs3"
                                        [floatingFilter]="false" [rowSelection]="'multiple'" #gridList
                                        [overlayNoRowsTemplate]="noRowsTemplate">
                                    </app-list-grid-angular>
                                </div>
                            </div>
                            <div class="home-dashboard__mini-footer">
                                <span class="home-dashboard__mini-footer-text">Tổng số {{listsData3.length}} kết
                                    quả</span>
                            </div>
                        </div>

                        <!-- Column 3: Newly Registered Assets -->
                        <div class="home-dashboard__mini-card">
                            <div class="home-dashboard__mini-header">
                                <div class="flex items-center gap-2">
                                    <h3 class="home-dashboard__mini-title">Mới đăng ký
                                    </h3>
                                    <button
                                        class="home-dashboard__icon-button home-dashboard__icon-button--compact hover:text-blue-600">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            class="home-dashboard__icon home-dashboard__icon--compact">
                                            <path fill-rule="evenodd"
                                                d="M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </button>
                                </div>
                                <button
                                    class="!w-8 !h-8 !min-w-[32px] !min-h-[32px] !p-0 flex-none self-center flex items-center justify-center bg-card border border-primary text-secondary rounded-lg hover:bg-[#ebf3ff] transition-colors shadow-sm">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            aria-hidden="true" data-slot="icon" class="w-6 h-6 text-primary">
                                            <path
                                                d="M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z">
                                            </path>
                                        </svg>
                                </button>
                            </div>
                            <div class="home-dashboard__mini-body">
                                <div class="grid-default" #container>
                                    <app-list-grid-angular *ngIf="columnDefs4.length > 0 && heightGrid > 0"
                                        [listsData]="listsData4" [height]="heightGrid1" [columnDefs]="columnDefs4"
                                        [floatingFilter]="false" [rowSelection]="'multiple'" #gridList
                                        [overlayNoRowsTemplate]="noRowsTemplate">
                                    </app-list-grid-angular>
                                </div>
                            </div>
                            <div class="home-dashboard__mini-footer">
                                <span class="home-dashboard__mini-footer-text">Tổng số {{listsData4.length}} kết
                                    quả</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Sidebar Area Start -->
        <aside
            class="mt-3 mr-3 rounded-lg w-[360px] h-[860px] bg-white border-l border-slate-200 flex-shrink-0 flex flex-col overflow-hidden shadow-lg relative z-0">
            <div class="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
                <h3 class="text-slate-800 font-semibold text-base m-0">Tài sản gần đây</h3>
            </div>

            <div class="px-3 pt-3">
                <div class="flex items-center bg-slate-100 border gap-1 border-slate-200 p-1 w-fit rounded-lg">
                    <button class="px-3 py-1.5 rounded-lg bg-[#045cc7] text-white border-none cursor-pointer">
                        <h4 class="m-0 text-[13px] font-medium">Tất cả</h4>
                    </button>
                    <button
                        class="px-3 py-1.5 rounded-lg text-slate-500 hover:bg-slate-200 border-none bg-transparent cursor-pointer transition-colors">
                        <span class="text-[13px] font-medium">Cần xử lý</span>
                    </button>
                    <button
                        class="px-3 py-1.5 rounded-lg text-slate-500 hover:bg-slate-200 border-none bg-transparent cursor-pointer transition-colors">
                        <span class="text-[13px] font-medium">Sắp hết hạn</span>
                    </button>
                </div>
            </div>

            <div class="flex-1 overflow-y-auto p-4 relative min-h-0">
                <div class="absolute left-[23px] top-5 bottom-5 w-px bg-slate-200"></div>
                <div class="space-y-5">
                    <div *ngFor="let event of (events ? (showMore ? events : events.slice(0, 10)) : []); let i = index"
                        class="relative pl-10">
                        <!-- Active dot -->
                        <div *ngIf="i === 0"
                            class="absolute left-0 top-1 w-4 h-4 rounded-full border-2 border-[#045cc7] bg-white shadow-[0_0_8px_rgba(37,99,235,0.4)] z-10 flex items-center justify-center">
                            <div class="w-1.5 h-1.5 bg-[#045cc7] rounded-full animate-ping"></div>
                        </div>
                        <!-- Inactive dot -->
                        <div *ngIf="i !== 0"
                            class="absolute left-0 top-1 w-4 h-4 rounded-full border-2 border-slate-200 bg-white z-10">
                        </div>

                        <h5 class="uppercase tracking-tighter mb-1.5 text-xs font-bold"
                            [ngClass]="i === 0 ? 'text-[#045cc7]' : 'text-slate-400'">
                            {{ event.created | date:"HH:mm - dd/MM/yyyy" }}
                        </h5>

                        <div class="flex items-start justify-between gap-3">
                            <div class="min-w-0">
                                <h4 class="text-slate-800 truncate font-bold text-sm m-0">{{ event.name }}</h4>
                                <div class="text-slate-400 mt-1 flex items-center gap-1.5 italic text-xs">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        aria-hidden="true" class="w-3 h-3 shrink-0">
                                        <path fill-rule="evenodd"
                                            d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                    {{ event.created_by }}
                                </div>
                            </div>

                            <h5 *ngIf="i % 5 === 0"
                                class="px-1.5 py-0.5 rounded bg-blue-100 text-blue-700 shrink-0 m-0 text-[11px] font-medium">
                                {{ event.status || 'New' }}</h5>
                            <h5 *ngIf="i % 5 === 1"
                                class="px-1.5 py-0.5 rounded bg-emerald-100 text-emerald-700 shrink-0 m-0 text-[11px] font-medium">
                                {{ event.status || 'Update' }}</h5>
                            <h5 *ngIf="i % 5 === 2"
                                class="px-1.5 py-0.5 rounded bg-orange-100 text-orange-700 shrink-0 m-0 text-[11px] font-medium">
                                {{ event.status || 'Alert' }}</h5>
                            <h5 *ngIf="i % 5 === 3"
                                class="px-1.5 py-0.5 rounded bg-red-100 text-red-700 shrink-0 m-0 text-[11px] font-medium">
                                {{ event.status || 'Delete' }}</h5>
                            <h5 *ngIf="i % 5 === 4"
                                class="px-1.5 py-0.5 rounded bg-slate-100 text-slate-600 shrink-0 m-0 text-[11px] font-medium">
                                {{ event.status || 'Log' }}</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div class="p-3 border-slate-200 bg-slate-50 text-center cursor-pointer" (click)="handleShowMore()">
                <h4 class="text-primary hover:underline text-xs font-bold">{{ showMore ? 'Thu gọn lịch sử' : 'Xem
                    lịch sử đầy đủ' }}</h4>
            </div>
        </aside>
    </div>

</div>